"use client"

import Text from "@/components/common/Typography/Text"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { faSort } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Select, theme } from "antd"
import { useTranslation } from "react-i18next"

const TourCategorySort = () => {
  const token = theme.useToken().token
  const dispatch = useAppDispatch()
  const categorySort = useAppSelector((state) => state.tour.formSearch.categorySort)
  const { t } = useTranslation()

  const options = [
    { value: "", label: t("common.recommended") },
    { value: "1", label: t("common.best_deal") },
    { value: "2", label: t("common.top_rated") },
    { value: "3", label: t("tour.duration") },
    { value: "4", label: t("tour.departure_date") },
    { value: "5", label: t("tour.price_higest_lowest") },
    { value: "6", label: t("tour.price_lowest_higest") },
  ].map((v) => ({
    ...v,
    shownTitle: (
      <>
        {t("tour.sort_by")}{" "}
        <Text strong style={{ color: token.colorPrimaryText }}>
          {v.label}
        </Text>
      </>
    ),
  }))

  return (
    <Select
      size="large"
      className="tour-category__sort"
      optionLabelProp="shownTitle"
      prefix={<FontAwesomeIcon icon={faSort} />}
      options={options}
      value={categorySort ?? ""}
      onChange={(value) => dispatch(tourActions.setTourCategorySort(value || undefined))}
    />
  )
}

export default TourCategorySort
